import React, {Component, ReactNode} from 'react'
import {MeetingRepositoryForAdmin} from './MeetingRepositoryForAdmin'
import {AdminPagePropsSet, createAdminPage} from '../shared/hoc/createAdminPage'
import {Nullable, Optional} from '../../app/TypeHelpers'
import PPSelect, {OptionProps} from '../shared/forms/PPSelect'
import {valueOrNoSelected} from '../../componentHelper/selectHelper'
import {getManageAttendanceInfo, MeetingAttachment} from './model/Meeting'
import {DeleteLink, EditLink, StyledLink} from '../../styledComponents/adminPage/Links'
import {HeadingAreaMessageParams} from '../shared/pageBaseComponents/HeadingAreaMessageComponent'
import MeetingSimple from './model/MeetingSimple'
import {Messages} from '../../Messages'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faExclamationCircle, faMapMarkerAlt} from '@fortawesome/free-solid-svg-icons'
import {faClock, faFile} from '@fortawesome/free-regular-svg-icons'
import {Box, Dialog, Divider, Paper, Table, TableBody, TableCell, TableHead, TableRow} from '@mui/material'
import {
    formatDateTimeForUpdateDate,
    formatDateWithDayOfTheWeek,
    formatForDateInputFromDate,
} from '../../formatters/formatDate'
import Time from '../../dateHelpers/Time'
import {
    FullWidthLeftColumnFlexContainer,
    LeftRowFlexContainer,
    LeftTopRowFlexContainer,
    RowFlexContainer,
} from '../../styledComponents/FlexComponents'
import {Colors} from '../../styledComponents/Constants'
import {
    getFileExtension,
    getQueryParameter,
    judgeAuthorityCheck,
    judgeRoleCheck,
} from '../../__NoAutomatedTests/common/util/Natutil'
import {getLinkIconComponent, IconBox, IconBoxContainer} from './AssocDirectorCommon'
import NatCurrentDateTimeRepo
    from '../../__NoAutomatedTests/components/currentDateTime/repository/NatCurrentDateTimeRepo'
import {
    NatGetCurrentDateTime,
} from '../../__NoAutomatedTests/components/currentDateTime/repository/NatGetCurrentDateTime'
import moment, {Moment} from 'moment'
import {VictoryPie} from 'victory'
import {MeetingForAdmin} from './model/MeetingForAdmin'
import {ATTENDANCE_STATUS, AVAILABLE_OR_NOT, MESSAGE_TYPE, ROLE_FOR_ADMINISTRATOR} from '../../CodeMaster'
import NatAdminUserRepo from '../../__NoAutomatedTests/components/adminUser/repository/NatAdminUserRepo'
import AdminMeetingAttendanceDialog, {MeetingAttendanceRecord} from './AdminMeetingAttendanceDialog'
import {AdminMeetingCommentArea} from './components/AdminMeetingCommentArea'
import {AdminPrimaryButton, AdminPrimaryOutlinedButton} from '../../styledComponents/adminPage/Buttons'
import {AdminMeetingNotifyDialog} from './AdminMeetingNotifyDialog'
import {MeetingHelper} from './utils/MeetingHelper'
import {StyledPre} from '../../styledComponents/adminPage/StyledPre'
import {AdminMeetingAttendanceReplyRequestDialog} from './AdminMeetingAttendanceReplyRequestDialog'
import {numberOrNull} from '../../stringHelper/stringHelpers'
import {HKConstants} from '../../HKConstants'
import styled from 'styled-components'
import {SessionStorageHelper} from '../../SessionStorageHelper'
import {AdminNotificationReceiveSettingRepo} from '../notificationReceiveSetting/AdminNotificationReceiveSettingRepo'
import MeetingNotificationReceiveSetting from '../notificationReceiveSetting/MeetingNotificationReceiveSetting'
import {FileOrLinkNameStyle} from './AdminMeetingForm'
import {AssocDirectorHelper} from './utils/AssocDirectorHelper'
import {NoWrapSpan} from './shared/AssocComponents'
import {KEY_MEETING_LIST_SEARCH_CONDITION} from '../../app/AdminSessionUtil'
import {SelectChangeEvent} from '@mui/material/Select'
import {Location} from 'react-router-dom'

const SELECTED_CONDOMINIUM_NAME: string = 'selectedCondominiumName'

interface LocationState {
    initialMessage: HeadingAreaMessageParams
    meetingId: number
    needToReceiveNotification?: boolean
}

interface Props {
    condominiumCd: string
    meetingRepoForAdmin: MeetingRepositoryForAdmin
    adminNotificationReceiveSettingRepo: AdminNotificationReceiveSettingRepo
    currentDateTimeRepo: NatCurrentDateTimeRepo
    natAdminUserRepo: NatAdminUserRepo
    location: Location<LocationState>
}

interface State {
    selectedCondominiumName: string
    meetings: MeetingSimple[]
    selectedMeeting: Nullable<MeetingForAdmin>
    attendanceResponsesDialogOpen: boolean
    meetingAttendanceRecords: MeetingAttendanceRecord[]
    meetingAnnounceNotifyDialogOpen: boolean
    meetingAttendanceReplyRequestDialogOpen: boolean
    notifyTitle: string
    notifyBody: string
    editAttendanceReplyDeadline: Nullable<Date>
    editProxyAttendanceAvailability: Nullable<string>
    meetingAttendanceReplyRequestDialogFlowNumber: number
    currentDateTime: Moment
    haveEditAuthority: boolean
    haveManageAttendanceAuthority: boolean
    havePostCommentAuthority: boolean
    isLoadCompleted: boolean
}

class AdminMeetingListPage extends Component<Props & AdminPagePropsSet, State> {
    constructor(props: Readonly<Props & AdminPagePropsSet>) {
        super(props)

        this.state = {
            selectedCondominiumName: '',
            meetings: [],
            selectedMeeting: null,
            attendanceResponsesDialogOpen: false,
            meetingAttendanceRecords: [],
            meetingAnnounceNotifyDialogOpen: false,
            meetingAttendanceReplyRequestDialogOpen: false,
            notifyTitle: '',
            notifyBody: '',
            editAttendanceReplyDeadline: null,
            editProxyAttendanceAvailability: null,
            meetingAttendanceReplyRequestDialogFlowNumber: 0,
            currentDateTime: moment(),
            haveEditAuthority: false,
            haveManageAttendanceAuthority: false,
            havePostCommentAuthority: false,
            isLoadCompleted: false,
        }

        this.handleMeetingChange = this.handleMeetingChange.bind(this)
        this.handleClickEditButton = this.handleClickEditButton.bind(this)
        this.handleClickShowMeetingAttendanceResponses = this.handleClickShowMeetingAttendanceResponses.bind(this)
        this.handleClickDeleteButton = this.handleClickDeleteButton.bind(this)
        this.handleDeleteOkButtonClick = this.handleDeleteOkButtonClick.bind(this)
        this.handleDeleteCancelButtonClick = this.handleDeleteCancelButtonClick.bind(this)
        this.handleCloseForAttendanceResponsesDialog = this.handleCloseForAttendanceResponsesDialog.bind(this)
        this.handleShowForMeetingAnnounceDialog = this.handleShowForMeetingAnnounceDialog.bind(this)
        this.handleShowForMeetingAttendanceReplyRequestDialog =
            this.handleShowForMeetingAttendanceReplyRequestDialog.bind(this)
        this.handleNotifyForMeetingAnnounceDialog = this.handleNotifyForMeetingAnnounceDialog.bind(this)
        this.handleCloseForMeetingAnnounceDialog = this.handleCloseForMeetingAnnounceDialog.bind(this)
        this.handleNotifyForMeetingAttendanceReplyRequestDialog =
            this.handleNotifyForMeetingAttendanceReplyRequestDialog.bind(this)
        this.handleCloseForMeetingAttendanceReplyRequestDialog =
            this.handleCloseForMeetingAttendanceReplyRequestDialog.bind(this)
        this.handleChangeForMeetingAttendanceReplyRequestDialogItem =
            this.handleChangeForMeetingAttendanceReplyRequestDialogItem.bind(this)
        this.handleNextFlowForMeetingAttendanceReplyRequestDialog =
            this.handleNextFlowForMeetingAttendanceReplyRequestDialog.bind(this)
        this.handleBackFlowForMeetingAttendanceReplyRequestDialog =
            this.handleBackFlowForMeetingAttendanceReplyRequestDialog.bind(this)
    }

    async componentDidMount(): Promise<void> {
        try {
            const selectedCondominiumName = SessionStorageHelper.getStringItemOrNull(SELECTED_CONDOMINIUM_NAME)
            if (!selectedCondominiumName) {
                return
            }

            this.setState({
                selectedCondominiumName: selectedCondominiumName,
                haveEditAuthority: judgeAuthorityCheck(HKConstants.CMN.AUTH.EDIT_ASSOC_DIRECTOR),
                haveManageAttendanceAuthority:
                    judgeAuthorityCheck(HKConstants.CMN.AUTH.MANAGE_ATTENDANCE_ASSOC_DIRECTOR),
                havePostCommentAuthority: judgeAuthorityCheck(HKConstants.CMN.AUTH.POST_COMMENT_ASSOC_DIRECTOR),
            })

            let meetingId: Optional<number>
            const beforeSelectedmeetingId =
                SessionStorageHelper.getNumberItemOrNull(KEY_MEETING_LIST_SEARCH_CONDITION)
            if (beforeSelectedmeetingId) {
                const meetings = await this.getMeetings()
                if (meetings) {
                    const meetingSimple = meetings.find(meeting => meeting.id === beforeSelectedmeetingId)
                    if (meetingSimple) {
                        meetingId = beforeSelectedmeetingId
                    }
                }
            }

            let needToReceiveNotification: boolean = false
            if (this.props.location && this.props.location.state) {
                meetingId = this.props.location.state.meetingId
                needToReceiveNotification = this.props.location.state.needToReceiveNotification === true
                const initialMessage: HeadingAreaMessageParams = this.props.location.state.initialMessage
                this.props.navigate(this.props.location.pathname, {replace: true})
                await this.props.eventEmitter.showHeadingAreaMessage(initialMessage)
            }

            const search = numberOrNull(getQueryParameter('meetingId', this.props.location.search))
            if (search !== null) {
                meetingId = search
            }

            await this.initPage(meetingId)

            if (needToReceiveNotification) {
                await this.followReceiveNotification()
            }
        } finally {
            this.setState({isLoadCompleted: true})
        }
    }

    followReceiveNotification = async (afterFunc?: () => Promise<void>): Promise<void> => {
        if (!judgeRoleCheck([ROLE_FOR_ADMINISTRATOR.FRONT_STAFF.value])) {
            if (undefined !== afterFunc) {
                await afterFunc()
            }
            return
        }

        const {condominiumCd, asyncCallFunction, adminNotificationReceiveSettingRepo, eventEmitter} = this.props

        await eventEmitter.showLoading()
        try {
            const receiveSetting: Nullable<MeetingNotificationReceiveSetting> = await asyncCallFunction(
                adminNotificationReceiveSettingRepo.getMeetingNotificationReceiveSetting.bind(
                    adminNotificationReceiveSettingRepo,
                    condominiumCd,
                ),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )

            if (!receiveSetting || receiveSetting.isReceive) {
                if (undefined !== afterFunc) {
                    await afterFunc()
                }
                return
            }

            await asyncCallFunction(
                adminNotificationReceiveSettingRepo.updateNotificationReceiveSetting.bind(
                    adminNotificationReceiveSettingRepo,
                    condominiumCd,
                    true,
                ),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )
        } finally {
            eventEmitter.closeLoading()
        }

        await eventEmitter.showDialog({
                title: '確認',
                errorLevel: MESSAGE_TYPE.INFORMATION,
                message: 'この物件の理事会に関する各種通知の受信設定がONになりました。設定は全体モードの通知管理メニューからいつでも変更できます。',
                buttonProps: [{
                    isDefault: false,
                    buttonLabel: 'OK',
                    buttonHandler: async () => {
                        eventEmitter.closeDialog()
                        if (undefined !== afterFunc) {
                            await afterFunc()
                        }
                    },
                }],
            },
        )
    }

    async initPage(meetingId?: number): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            const [meetings, currentDateTime] = await Promise.all([this.getMeetings(), this.getCurrentDateTime()])
            if (currentDateTime === null || currentDateTime.details === null || meetings === null) {
                return
            }

            const currentDatetimeMoment = moment(currentDateTime.details.currentDateTime)
            let meetingDetail: Nullable<MeetingForAdmin> = null
            if (meetings.length > 0) {
                const nextMeeting = MeetingHelper.getNextMeeting(meetings, currentDatetimeMoment)
                const searchMeetingId: number = meetingId ?? nextMeeting?.id ?? meetings[meetings.length - 1].id
                meetingDetail = await this.getMeetingByMeetingId(searchMeetingId)
                if (meetingDetail === null) {
                    return
                }
                SessionStorageHelper.setItem(KEY_MEETING_LIST_SEARCH_CONDITION, meetingDetail.id)
            }


            this.setState({
                meetings: meetings,
                selectedMeeting: meetingDetail,
                meetingAttendanceRecords: meetingDetail === null ?
                    [] : this.createMeetingAttendanceRecords(meetingDetail),
                currentDateTime: currentDatetimeMoment,
            })
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    createMeetingAttendanceRecords(meeting: MeetingForAdmin): MeetingAttendanceRecord[] {
        return meeting.participantAssocDirectorList.map(participant => {
            const {
                adminId,
                familyName,
                firstName,
                roomList,
                meetingAttendanceResponse,
                isWithinTerm,
                hasMailAddress,
            } = participant
            const roomNumberSortKey = MeetingHelper.getRoomListSortKeyByResidentStatus(roomList)
            return meetingAttendanceResponse === null ?
                {
                    attendanceId: null,
                    attendanceStatus: ATTENDANCE_STATUS.UNANSWERED,
                    adminId,
                    familyName,
                    firstName,
                    roomList,
                    roomNumberSortKey,
                    responseDateTime: null,
                    proxyUserName: null,
                    proxyUserRelationship: null,
                    note: null,
                    agentRespondentAdminId: null,
                    agentRespondentName: '',
                    agentRespondentRoleName: '',
                    version: null,
                    isWithinTerm,
                    hasMailAddress,
                } :
                {
                    attendanceId: meetingAttendanceResponse.attendanceId,
                    attendanceStatus: meetingAttendanceResponse.attendanceStatus,
                    adminId,
                    familyName,
                    firstName,
                    roomList,
                    roomNumberSortKey,
                    responseDateTime: meetingAttendanceResponse.responseDateTime,
                    proxyUserName: meetingAttendanceResponse.proxyUserName,
                    proxyUserRelationship: meetingAttendanceResponse.proxyUserRelationship,
                    note: meetingAttendanceResponse.note,
                    agentRespondentAdminId: meetingAttendanceResponse.agentRespondentAdminId,
                    agentRespondentName: meetingAttendanceResponse.agentRespondentName,
                    agentRespondentRoleName: meetingAttendanceResponse.agentRespondentRoleName,
                    version: meetingAttendanceResponse.version,
                    isWithinTerm,
                    hasMailAddress,
                }
        })
    }

    async handleMeetingChange(event: SelectChangeEvent<unknown>): Promise<void> {
        this.props.eventEmitter.clearHeadingAreaMessage()

        const meetingId = Number(event.target.value)

        await this.props.eventEmitter.showLoading()
        try {
            const [selectedMeeting, currentDateTime] =
                await Promise.all([this.getMeetingByMeetingId(meetingId), this.getCurrentDateTime()])
            if (currentDateTime === null || currentDateTime.details === null || selectedMeeting === null) {
                return
            }

            const currentDatetimeMoment = moment(currentDateTime.details.currentDateTime)

            SessionStorageHelper.setItem(KEY_MEETING_LIST_SEARCH_CONDITION, meetingId)

            this.setState({
                selectedMeeting,
                meetingAttendanceRecords: this.createMeetingAttendanceRecords(selectedMeeting),
                currentDateTime: currentDatetimeMoment,
            })
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    handleClickEditButton(): void {
        if (this.state.selectedMeeting == null) {
            return
        }
        this.props.navigate(`/admin/condominiums/${this.props.condominiumCd}/meetings/${this.state.selectedMeeting.id}/edit`)
    }

    handleClickDeleteButton(): void {
        this.props.eventEmitter.clearHeadingAreaMessage()

        if (this.state.selectedMeeting === null) {
            return
        }
        this.props.eventEmitter.showDialog({
                title: '確認',
                errorLevel: Messages.IOPCC0011.errorLevel,
                message: Messages.IOPCC0011.toString(this.state.selectedMeeting.name),
                buttonProps: [
                    {
                        isDefault: false,
                        buttonLabel: 'キャンセル',
                        buttonHandler: this.handleDeleteCancelButtonClick,
                    },
                    {
                        isDefault: false,
                        buttonLabel: 'OK',
                        buttonHandler: this.handleDeleteOkButtonClick,
                    },
                ],
            },
        )
    }

    async handleClickShowMeetingAttendanceResponses(): Promise<void> {
        this.props.eventEmitter.clearHeadingAreaMessage()

        if (this.state.selectedMeeting === null) {
            return
        }

        this.setState({
            attendanceResponsesDialogOpen: true,
        })
    }

    async handleShowForMeetingAnnounceDialog(): Promise<void> {
        const {
            condominiumCd,
            eventEmitter,
            asyncCallFunction,
            meetingRepoForAdmin,
        } = this.props
        const {
            selectedMeeting,
        } = this.state

        eventEmitter.clearHeadingAreaMessage()

        if (selectedMeeting === null) {
            return
        }

        await eventEmitter.showLoading()

        try {
            const mailContent = await asyncCallFunction(
                meetingRepoForAdmin.getMeetingAnnounceContent.bind(
                    meetingRepoForAdmin,
                    condominiumCd,
                    selectedMeeting.id,
                    selectedMeeting.version,
                ),
                (httpErrorOrNetworkError) => {
                    eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )

            if (mailContent === null) {
                return
            }

            this.setState({
                meetingAnnounceNotifyDialogOpen: true,
                notifyTitle: mailContent.title,
                notifyBody: mailContent.body,
            })
        } finally {
            eventEmitter.closeLoading()
        }
    }

    async handleShowForMeetingAttendanceReplyRequestDialog(): Promise<void> {
        this.props.eventEmitter.clearHeadingAreaMessage()

        const {selectedMeeting} = this.state
        if (selectedMeeting === null) {
            return
        }

        this.setState({
            meetingAttendanceReplyRequestDialogOpen: true,
            editAttendanceReplyDeadline: selectedMeeting.attendanceReplyDeadline?.toDate() ?? null,
            editProxyAttendanceAvailability: selectedMeeting.proxyAttendanceAvailability?.value ?? null,
            meetingAttendanceReplyRequestDialogFlowNumber: 1,
        })
    }

    async handleNotifyForMeetingAnnounceDialog(): Promise<void> {
        this.handleCloseForMeetingAnnounceDialog()

        await this.followReceiveNotification(this.notifyAnnounce)
    }

    notifyAnnounce = async (): Promise<void> => {
        const {meetingRepoForAdmin, condominiumCd, asyncCallFunction} = this.props
        const {selectedMeeting, notifyTitle, notifyBody} = this.state

        if (selectedMeeting === null) {
            return
        }

        await this.props.eventEmitter.showLoading()

        try {
            const result = await asyncCallFunction(
                // @ts-ignore
                meetingRepoForAdmin.sendMeetingAnnounce.bind(
                    meetingRepoForAdmin,
                    condominiumCd,
                    notifyTitle,
                    notifyBody,
                    selectedMeeting.id,
                    selectedMeeting.date,
                    selectedMeeting.version),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )
            if (result === null) {
                return
            }

            const updatedSelectMeeting = await this.getMeetingByMeetingId(selectedMeeting.id)
            if (updatedSelectMeeting === null) {
                return
            }

            this.setState({
                selectedMeeting: updatedSelectMeeting,
            })

        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    async handleNotifyForMeetingAttendanceReplyRequestDialog(): Promise<void> {
        this.setState({meetingAttendanceReplyRequestDialogOpen: false})

        await this.followReceiveNotification(this.notifyMeetingAttendanceReply)
    }

    notifyMeetingAttendanceReply = async (): Promise<void> => {
        const {meetingRepoForAdmin, condominiumCd, asyncCallFunction} = this.props
        const {
            selectedMeeting,
            notifyTitle,
            notifyBody,
            editAttendanceReplyDeadline,
            editProxyAttendanceAvailability,
        } = this.state
        if (selectedMeeting === null
            || editAttendanceReplyDeadline === null
            || editProxyAttendanceAvailability === null) {
            return
        }

        await this.props.eventEmitter.showLoading()
        try {
            const result = await asyncCallFunction(
                // @ts-ignore
                meetingRepoForAdmin.sendMeetingAttendanceReplyRequest.bind(
                    meetingRepoForAdmin,
                    condominiumCd,
                    notifyTitle,
                    notifyBody,
                    selectedMeeting.id,
                    selectedMeeting.date,
                    formatForDateInputFromDate(editAttendanceReplyDeadline),
                    editProxyAttendanceAvailability,
                    selectedMeeting.version,
                ),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )
            if (result === null) {
                return
            }

            const updatedSelectMeeting = await this.getMeetingByMeetingId(selectedMeeting.id)
            if (updatedSelectMeeting === null) {
                return
            }

            this.setState({
                selectedMeeting: updatedSelectMeeting,
            })
        } finally {
            this.handleCloseForMeetingAttendanceReplyRequestDialog()
            this.props.eventEmitter.closeLoading()
        }
    }

    handleCloseForMeetingAnnounceDialog(): void {
        this.setState({meetingAnnounceNotifyDialogOpen: false})
    }

    handleCloseForMeetingAttendanceReplyRequestDialog(): void {
        this.setState({
            meetingAttendanceReplyRequestDialogOpen: false,
            editAttendanceReplyDeadline: null,
            editProxyAttendanceAvailability: null,
            meetingAttendanceReplyRequestDialogFlowNumber: 0,
        })
    }

    handleChangeForMeetingAttendanceReplyRequestDialogItem(
        attendanceReplyDeadline: Nullable<Date>,
        proxyAttendanceAvailability: Nullable<string>,
    ): void {
        this.setState({
            editAttendanceReplyDeadline: attendanceReplyDeadline,
            editProxyAttendanceAvailability: proxyAttendanceAvailability,
        })
    }

    async handleNextFlowForMeetingAttendanceReplyRequestDialog(): Promise<void> {
        const {
            condominiumCd,
            eventEmitter,
            asyncCallFunction,
            meetingRepoForAdmin,
        } = this.props
        const {
            selectedMeeting,
            editAttendanceReplyDeadline,
            editProxyAttendanceAvailability,
        } = this.state
        if (selectedMeeting === null
            || editAttendanceReplyDeadline === null
            || editProxyAttendanceAvailability === null) {
            return
        }

        await eventEmitter.showLoading()

        try {
            const mailContent = await asyncCallFunction(
                meetingRepoForAdmin.getMeetingAttendanceReplyRequestContent.bind(
                    meetingRepoForAdmin,
                    condominiumCd,
                    selectedMeeting.id,
                    formatForDateInputFromDate(editAttendanceReplyDeadline),
                    selectedMeeting.version,
                ),
                (httpErrorOrNetworkError) => {
                    eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )

            if (mailContent === null) {
                return
            }

            this.setState({
                meetingAttendanceReplyRequestDialogFlowNumber: 2,
                notifyTitle: mailContent.title,
                notifyBody: mailContent.body,
            })
        } finally {
            eventEmitter.closeLoading()
        }

        const selectedMeetingDate = selectedMeeting.date
        if (selectedMeetingDate === null) {
            return
        }
    }

    handleBackFlowForMeetingAttendanceReplyRequestDialog(): void {
        this.setState({
            meetingAttendanceReplyRequestDialogFlowNumber: 1,
            notifyTitle: '',
            notifyBody: '',
        })
    }

    handleDeleteCancelButtonClick(): void {
        this.props.eventEmitter.closeDialog()
    }

    async handleDeleteOkButtonClick(): Promise<void> {
        const {meetingRepoForAdmin, condominiumCd, asyncCallFunction} = this.props
        const {selectedMeeting} = this.state
        if (selectedMeeting === null) {
            return
        }

        this.props.eventEmitter.closeDialog()

        await this.props.eventEmitter.showLoading()
        try {
            const deleteMeetingResponse = await asyncCallFunction(
                meetingRepoForAdmin.deleteMeeting.bind(
                    meetingRepoForAdmin,
                    condominiumCd,
                    selectedMeeting.id,
                    selectedMeeting.version,
                ),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )
            if (deleteMeetingResponse === null) {
                return
            }

            await this.props.eventEmitter.showHeadingAreaMessage({
                title: deleteMeetingResponse.information.title || '',
                messageLevel: deleteMeetingResponse.information.type,
                detail: deleteMeetingResponse.information.message,
            })

            await this.initPage()

        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    async handleCloseForAttendanceResponsesDialog(): Promise<void> {
        this.setState({attendanceResponsesDialogOpen: false})
        if (!this.state.selectedMeeting) {
            return
        }
        await this.initPage(this.state.selectedMeeting.id)
    }

    async getMeetingByMeetingId(meetingId: number): Promise<Nullable<MeetingForAdmin>> {
        const {condominiumCd, meetingRepoForAdmin, asyncCallFunction} = this.props

        let meeting: Nullable<MeetingForAdmin>
        meeting = await asyncCallFunction(
            meetingRepoForAdmin.getMeeting.bind(meetingRepoForAdmin, condominiumCd, meetingId),
            (httpErrorOrNetworkError) => {
                this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
            },
        )

        return meeting
    }

    async getMeetings(): Promise<Nullable<MeetingSimple[]>> {
        const {meetingRepoForAdmin, condominiumCd} = this.props
        await this.props.eventEmitter.showLoading()
        let meetings: Nullable<MeetingSimple[]>
        try {
            meetings = await this.props.asyncCallFunction(
                meetingRepoForAdmin.getMeetings.bind(meetingRepoForAdmin, condominiumCd),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )
        } finally {
            this.props.eventEmitter.closeLoading()
        }

        return meetings
    }

    async getCurrentDateTime(): Promise<Nullable<NatGetCurrentDateTime>> {
        const {currentDateTimeRepo, asyncCallFunction} = this.props

        await this.props.eventEmitter.showLoading()
        let currentDateTime: Nullable<NatGetCurrentDateTime> = null
        try {
            currentDateTime = await asyncCallFunction(
                currentDateTimeRepo.getCurrentDateTime.bind(currentDateTimeRepo),
                async (httpErrorOrNetworkError) => {
                    await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                },
            )
        } finally {
            this.props.eventEmitter.closeLoading()
        }
        return currentDateTime
    }

    renderMeetingAttachmentFilesTable(fileList: MeetingAttachment[]): ReactNode {
        return fileList.map((file, index) => {
            return <TableRow key={`file-${index}`}>
                <TableCell>
                    <StyledLink to={file.uri}>
                        <LeftRowFlexContainer>
                            <AttachmentFileStyle>
                                {getLinkIconComponent(getFileExtension(file.displayName))}
                            </AttachmentFileStyle>
                            <FileOrLinkNameStyle>
                                {file.displayName}
                            </FileOrLinkNameStyle>
                        </LeftRowFlexContainer>
                    </StyledLink>
                </TableCell>
                <TableCell>
                    <NoWrapSpan>
                        {`${AssocDirectorHelper.getDisplayUserNameByResidentStatus(
                            file.registeredUserFamilyName, file.registeredUserFirstName, file.roomList,
                        )}　`}
                    </NoWrapSpan>
                    <NoWrapSpan>
                        <RoomNumberText>
                            {MeetingHelper.getDisplayRoomListOrRoleName(file.roleId, file.roomList)}
                        </RoomNumberText>
                    </NoWrapSpan>
                </TableCell>
                <NowrapCell>
                    {formatDateTimeForUpdateDate(file.registeredDatetime)}
                </NowrapCell>
            </TableRow>
        })
    }

    renderMeetingAttachmentLinksTable(linkList: MeetingAttachment[]): ReactNode {
        return linkList.map((link, index) => {
            return <TableRow key={`link-${index}`}>
                <TableCell>
                    <StyledLink
                        to={link.uri}
                        target={'_blank'}
                        rel={'noopener noreferrer'}
                    >
                        <LeftRowFlexContainer>
                            <AttachmentFileStyle>
                                {getLinkIconComponent()}
                            </AttachmentFileStyle>
                            {link.displayName}
                        </LeftRowFlexContainer>
                    </StyledLink>
                </TableCell>
                <TableCell>
                    <NoWrapSpan>
                        {`${AssocDirectorHelper.getDisplayUserNameByResidentStatus(
                            link.registeredUserFamilyName, link.registeredUserFirstName, link.roomList,
                        )}　`}
                    </NoWrapSpan>
                    <NoWrapSpan>
                        <RoomNumberText>
                            {MeetingHelper.getDisplayRoomListOrRoleName(link.roleId, link.roomList)}
                        </RoomNumberText>
                    </NoWrapSpan>
                </TableCell>
                <NowrapCell>
                    {formatDateTimeForUpdateDate(link.registeredDatetime)}
                </NowrapCell>
            </TableRow>
        })
    }

    renderMeetingReportsTable(reportList: MeetingAttachment[]): ReactNode {
        return reportList.map((report, index) => {
            return <TableRow key={`report-${index}`}>
                <TableCell>
                    <StyledLink to={report.uri}>
                        <LeftRowFlexContainer>
                            <AttachmentFileStyle>
                                {getLinkIconComponent(getFileExtension(report.displayName))}
                            </AttachmentFileStyle>
                            <FileOrLinkNameStyle>
                                {report.displayName}
                            </FileOrLinkNameStyle>
                        </LeftRowFlexContainer>
                    </StyledLink>
                </TableCell>
                <TableCell>
                    <NoWrapSpan>
                        {`${AssocDirectorHelper.getDisplayUserNameByResidentStatus(
                            report.registeredUserFamilyName, report.registeredUserFirstName, report.roomList,
                        )}　`}
                    </NoWrapSpan>
                    <NoWrapSpan>
                        <RoomNumberText>
                            {MeetingHelper.getDisplayRoomListOrRoleName(report.roleId, report.roomList)}
                        </RoomNumberText>
                    </NoWrapSpan>
                </TableCell>
                <NowrapCell>
                    {formatDateTimeForUpdateDate(report.registeredDatetime)}
                </NowrapCell>
            </TableRow>
        })
    }

    renderMeetingAnnounceArea(
        selectedMeeting: MeetingForAdmin,
        hasMeetingAssignableMember: boolean,
        isPastMeeting: boolean,
    ): ReactNode {
        let announceArea: ReactNode
        if (selectedMeeting.meetingAnnounceNotifyDatetime !== null) {
            announceArea = selectedMeeting.meetingAnnounceNotifyDatetime.format('M月D日(dd) HH:mm') + ' に送信済みです。'
        } else {
            let announceMessage
            let disableNotifyButton = true
            if (selectedMeeting.date === null) {
                announceMessage =
                    <WarningMessageArea>
                        <FontAwesomeIcon icon={faExclamationCircle} color={'#F5A623'} size={'lg'}/>
                        <Box width={'8px'}/>
                        開催案内を送信するには、開催日を登録してください。
                    </WarningMessageArea>
            } else if (isPastMeeting) {
                announceMessage = '会議の開催日を過ぎました。'
            } else if (!hasMeetingAssignableMember) {
                announceMessage =
                    <WarningMessageArea>
                        <FontAwesomeIcon icon={faExclamationCircle} color={'#F5A623'} size={'lg'}/>
                        <Box width={'8px'}/>
                        メンバーが登録されていません。
                    </WarningMessageArea>
            } else {
                announceMessage = '開催案内を送信してください。'
                disableNotifyButton = false
            }

            announceArea = <>
                {announceMessage}
                {
                    this.state.haveEditAuthority &&
                    <RowCenteringContainer>
                        <Box mt={'16px'}>
                            <NotifyButton
                                onClick={this.handleShowForMeetingAnnounceDialog}
                                disabled={disableNotifyButton}
                            >
                                開催案内を送信する
                            </NotifyButton>
                        </Box>
                    </RowCenteringContainer>
                }
            </>
        }

        return (
            <ComponentPaper elevation={2}>
                <Box p={'16px'}>開催案内</Box>
                <Divider/>
                <Box p={'16px 16px 24px'}>{announceArea}</Box>
            </ComponentPaper>
        )
    }

    renderMeetingAttendanceArea(
        selectedMeeting: MeetingForAdmin,
        hasMeetingAssignableMember: boolean,
        isPastMeeting: boolean,
    ): ReactNode {
        const {meetingRepoForAdmin, condominiumCd, eventEmitter} = this.props
        const {attendanceResponsesDialogOpen, meetingAttendanceRecords} = this.state
        const manageAttendanceInfo = getManageAttendanceInfo(selectedMeeting)
        if (manageAttendanceInfo === null) {
            return
        }
        const {
            attendanceReplyRequestDatetime,
            attendanceReplyDeadline,
            proxyAttendanceAvailability,
        } = manageAttendanceInfo

        let enableToAttendanceResponseRequest = false
        if (selectedMeeting.date !== null &&
            selectedMeeting.startTime !== null && selectedMeeting.endTime !== null &&
            (selectedMeeting.place !== null || selectedMeeting.url !== null)) {
            enableToAttendanceResponseRequest = true
        }

        let view: ReactNode
        const attendanceSetting = <>
            回答期限：{attendanceReplyDeadline.format('M月D日(dd)')}<br/>
            代理出席：{proxyAttendanceAvailability === AVAILABLE_OR_NOT.AVAILABLE ? '許可する' : '許可しない'}
        </>
        if (attendanceReplyRequestDatetime !== null) {
            view = <>
                {attendanceReplyRequestDatetime.format('M月D日(dd) HH:mm')} に依頼済みです。<br/>
                {attendanceSetting}
                {this.renderMeetingAttendanceReplyRequests(proxyAttendanceAvailability)}
            </>
        } else {
            let message: ReactNode
            let disableNotifyButton = true
            if (isPastMeeting) {
                message = '会議の開催日を過ぎました。'
            } else if (!this.state.haveManageAttendanceAuthority) {
                message = <>
                    出欠回答依頼は準備中です。<br/>
                    出欠回答が依頼されると、回答を確認できるようになります。
                </>
            } else if (!hasMeetingAssignableMember) {
                message =
                    <WarningMessageArea>
                        <FontAwesomeIcon icon={faExclamationCircle} color={'#F5A623'} size={'lg'}/>
                        <Box width={'8px'}/>
                        メンバーが登録されていません。
                    </WarningMessageArea>
            } else if (!enableToAttendanceResponseRequest) {
                message =
                    <WarningMessageArea>
                        <FontAwesomeIcon icon={faExclamationCircle} color={'#F5A623'} size={'lg'}/>
                        <Box width={'8px'}/>
                        出欠回答を依頼するには、開催要項(日時、場所)を登録してください。
                    </WarningMessageArea>
            } else {
                message = <>
                    <WarningMessageArea>
                        <FontAwesomeIcon icon={faExclamationCircle} color={'#F5A623'} size={'lg'}/>
                        <Box width={'8px'}/>
                        出欠回答を依頼してください。
                    </WarningMessageArea>
                    <Box height={'16px'}/>
                    {attendanceSetting}
                </>
                disableNotifyButton = false
            }

            view = <>
                {message}
                {
                    this.state.haveManageAttendanceAuthority &&
                    <>
                        <RowCenteringContainer>
                            <Box mt={'16px'} mb={'32px'}>
                                <NotifyButton
                                    onClick={this.handleShowForMeetingAttendanceReplyRequestDialog}
                                    disabled={disableNotifyButton}>
                                    出欠回答を依頼する
                                </NotifyButton>
                            </Box>
                        </RowCenteringContainer>
                        {!isPastMeeting && '出欠回答を依頼すると、回答を確認できるようになります。'}
                    </>
                }
                {
                    !isPastMeeting &&
                    this.renderBeforeAttendanceRequestGuide()
                }
            </>
        }

        return (
            <>
                <ComponentPaper elevation={2}>
                    <Box p={'16px'}>出欠確認</Box>
                    <Divider/>
                    <Box p={'16px 16px 24px'}>{view}</Box>
                </ComponentPaper>
                <Dialog
                    id={'pp-dialog'}
                    open={attendanceResponsesDialogOpen}
                    transitionDuration={(process.env.NODE_ENV === 'test') ? 0 : undefined}
                    maxWidth={'md'}
                    fullWidth
                >
                    <AdminMeetingAttendanceDialog
                        meetingRepositoryForAdmin={meetingRepoForAdmin}
                        meetingAttendanceRecords={meetingAttendanceRecords}
                        condominiumCd={condominiumCd}
                        meetingId={selectedMeeting.id}
                        proxyAttendanceAvailability={manageAttendanceInfo.proxyAttendanceAvailability}
                        isPastMeeting={isPastMeeting}
                        onClose={this.handleCloseForAttendanceResponsesDialog}
                        eventEmitter={eventEmitter}
                    />
                </Dialog>
            </>
        )
    }

    renderMeetingAttendanceReplyRequests(
        proxyAttendanceAvailability: AVAILABLE_OR_NOT,
    ): ReactNode {
        const {meetingAttendanceRecords, haveManageAttendanceAuthority} = this.state

        const baseData = [
            {
                name: ATTENDANCE_STATUS.ATTEND.label,
                count: meetingAttendanceRecords
                    .filter(c => c.attendanceStatus === ATTENDANCE_STATUS.ATTEND)
                    .length,
                color: 'rgb(167, 211, 236)',
            },
            {
                name: ATTENDANCE_STATUS.PROXY_ATTEND.label,
                count: meetingAttendanceRecords
                    .filter(c => c.attendanceStatus === ATTENDANCE_STATUS.PROXY_ATTEND)
                    .length,
                color: 'rgb(206, 231, 244)',
            },
            {
                name: ATTENDANCE_STATUS.ABSENT.label,
                count: meetingAttendanceRecords
                    .filter(c => c.attendanceStatus === ATTENDANCE_STATUS.ABSENT)
                    .length,
                color: 'rgb(250, 210, 145)',
            },
            {
                name: '未回答',
                count: meetingAttendanceRecords
                    .filter(c => c.attendanceStatus === ATTENDANCE_STATUS.UNANSWERED)
                    .length,
                color: 'rgb(236, 236, 236)',
            },
        ]
        const totalCount = baseData.reduce((sum, b) => sum + b.count, 0)
        if (totalCount === 0) {
            return null
        }

        const legendData = baseData.map(b => {
            return {...b, percent: (b.count / totalCount * 100).toFixed() + '%'}
        })
        const pieData = legendData
            .filter(p => p.count !== 0)
            .map(p => {
                return {
                    x: `${p.name}\n${p.percent}`,
                    y: p.count,
                    color: p.color,
                }
            })

        return <Box mt={'32px'}>
            <AttendanceArea>
                {this.renderVictoryPie(pieData, totalCount)}
                <Box width={'49px'}/>
                <Box margin={'20px 0'}>
                    {
                        legendData
                            .filter(l =>
                                !(proxyAttendanceAvailability === AVAILABLE_OR_NOT.UNAVAILABLE
                                    && l.name === ATTENDANCE_STATUS.PROXY_ATTEND.label
                                    && l.count === 0))
                            .map((l, index) =>
                                <AttendanceRow key={index}>
                                    <AttendanceIcon color={l.color}/>
                                    <Box component={'span'} width={'60px'} ml={'9px'} textAlign={'start'}>{l.name}</Box>
                                    <Box component={'span'} width={'60px'} textAlign={'end'}>{l.count}人(</Box>
                                    <Box component={'span'} width={'35px'} textAlign={'end'}>{l.percent})</Box>
                                </AttendanceRow>)
                    }
                </Box>
                <Box mt={'24px'}>
                    {
                        haveManageAttendanceAuthority ?
                            <AttendanceResponseViewButton onClick={this.handleClickShowMeetingAttendanceResponses}>
                                回答状況を確認する
                            </AttendanceResponseViewButton> :
                            <AdminPrimaryOutlinedButton onClick={this.handleClickShowMeetingAttendanceResponses}>
                                回答状況を確認する
                            </AdminPrimaryOutlinedButton>
                    }
                </Box>
            </AttendanceArea>
        </Box>
    }

    renderBeforeAttendanceRequestGuide(): ReactNode {
        const pieData = [
            {x: '', y: 3, color: 'rgb(217, 217, 217)'},
            {x: '', y: 1, color: 'rgb(232, 232, 232)'},
            {x: '', y: 1, color: 'rgb(247, 247, 247)'},
        ]
        const totalCount = 5

        return <AttendanceArea>
            <Box mt={'24px'}>
                {this.renderVictoryPie(pieData, totalCount)}
            </Box>
            <Box width={'49px'} mb={'24px'}/>
            {
                this.state.haveManageAttendanceAuthority ?
                    <AttendanceResponseViewButton disabled>
                        回答状況を確認する
                    </AttendanceResponseViewButton> :
                    <AdminPrimaryOutlinedButton disabled>
                        回答状況を確認する
                    </AdminPrimaryOutlinedButton>
            }
        </AttendanceArea>
    }

    renderVictoryPie(pieData: any[], totalCount: number): ReactNode {
        return <DropShadowSvg height={202} width={202}>
            <VictoryPie
                standalone={false}
                height={202}
                width={202}
                padding={1}
                data={pieData}
                labels={({datum}) => datum.y / totalCount > 0.05 ? datum.x : ''}
                colorScale={pieData.map(p => p.color)}
                labelRadius={60}
                innerRadius={30}
                style={{
                    data: {strokeWidth: 1, stroke: 'white'},
                    labels: {fontSize: 12, fill: Colors.Body, textAnchor: 'middle'},
                }}
            />
        </DropShadowSvg>
    }

    renderMemberArea(selectedMeeting: MeetingForAdmin, hasMeetingAssignableMember: boolean): ReactNode {
        return (
            <ComponentPaper elevation={2}>
                <Box p={'16px'}>
                    <RowFlexContainer>
                        メンバー
                    </RowFlexContainer>
                </Box>
                <Divider/>
                <Box pt={'10px'} pr={'16px'} pb={'10px'} pl={'16px'}>{
                    selectedMeeting.date === null ?
                        <Box pt={'6px'} pb={'14px'}>
                            <WarningMessageArea>
                                <FontAwesomeIcon icon={faExclamationCircle} color={'#F5A623'} size={'lg'}/>
                                <Box width={'8px'}/>
                                メンバーを確認するには、開催日を登録してください。
                            </WarningMessageArea>
                        </Box> :
                        !hasMeetingAssignableMember ? <div>会議の対象になる管理組合役員がいません。</div> :
                            selectedMeeting.participantAssocDirectorList.map(((participantAssocDirector, index) => {
                                const {
                                    roomList,
                                    familyName,
                                    firstName,
                                    isWithinTerm,
                                    hasMailAddress,
                                } = participantAssocDirector
                                const userIconNode: ReactNode = MeetingHelper.getUserIconNodeByResidentStatus(
                                    isWithinTerm,
                                    hasMailAddress,
                                    ROLE_FOR_ADMINISTRATOR.ASSOC,
                                    roomList,
                                    'medium')

                                return <div key={`member-${index}`}>
                                    {index !== 0 && <Divider/>}
                                    <MemberInfoBox>
                                        <Box mr={'10px'}>{userIconNode}</Box>
                                        <FullWidthLeftColumnFlexContainer>
                                            <div>
                                                {AssocDirectorHelper.getDisplayUserNameByResidentStatus(
                                                    familyName,
                                                    firstName,
                                                    roomList)}
                                            </div>
                                            <MemberRoomNumberText>
                                                <MemberRoomNumberTextBody>
                                                    {MeetingHelper.getDisplayRoomListByResidentStatus(roomList)}
                                                </MemberRoomNumberTextBody>
                                            </MemberRoomNumberText>
                                        </FullWidthLeftColumnFlexContainer>
                                    </MemberInfoBox>
                                </div>
                            }))
                }</Box>
            </ComponentPaper>
        )
    }

    renderMeetingDetailArea(selectedMeeting: MeetingForAdmin): ReactNode {
        let displayPeriod: string
        if (selectedMeeting.date === null) {
            displayPeriod = '日時未定'
        } else {
            const displayDate = formatDateWithDayOfTheWeek(selectedMeeting.date)
            if (selectedMeeting.startTime !== null && selectedMeeting.endTime !== null) {
                const displayStartTime = Time.fromString(selectedMeeting.startTime).toJSON()
                const displayEndTime = Time.fromString(selectedMeeting.endTime).toJSON()

                displayPeriod = displayDate + ` ${displayStartTime} 〜 ${displayEndTime}`
            } else {
                displayPeriod = displayDate + ' 時間未定'
            }
        }
        const placeInfos = []
        if (selectedMeeting.place) {
            placeInfos.push(selectedMeeting.place)
        }
        if (selectedMeeting.url) {
            placeInfos.push('オンライン参加可能')
        }
        const displayPlaceStr = placeInfos.join('、') || '場所未定'

        return (<>
            <ComponentPaper elevation={2}>
                <Box p={'16px'}>開催要項</Box>
                <Divider/>
                <Box p={'16px'}>
                    <IconBoxContainer>
                        <IconBox><FontAwesomeIcon icon={faClock}/></IconBox>
                        {displayPeriod}
                    </IconBoxContainer>
                    <IconBoxContainer>
                        <IconBox><FontAwesomeIcon icon={faMapMarkerAlt}/></IconBox>
                        {displayPlaceStr}
                    </IconBoxContainer>
                    {
                        selectedMeeting.memo &&
                        <IconBoxContainer>
                            <IconBox><FontAwesomeIcon icon={faFile}/></IconBox>
                            <StyledPre>{selectedMeeting.memo}</StyledPre>
                        </IconBoxContainer>
                    }
                    {
                        selectedMeeting.url &&
                        <Box pt={'15px'} pb={'15px'}>
                            <AdminPrimaryOutlinedButton onClick={() => {
                                window.open(selectedMeeting.url || '', '_blank', 'noreferrer')
                            }}>
                                オンライン会議に参加する
                            </AdminPrimaryOutlinedButton>
                        </Box>
                    }
                </Box>
            </ComponentPaper>
            {
                selectedMeeting.contents &&
                <ComponentPaper elevation={2}>
                    <Box p={'16px'}>議題・アジェンダ</Box>
                    <Divider/>
                    <Box p={'16px'}>
                        <StyledPre>{selectedMeeting.contents}</StyledPre>
                    </Box>
                </ComponentPaper>
            }
            {
                (selectedMeeting.meetingAttachmentFileList.length > 0 ||
                    selectedMeeting.meetingAttachmentLinkList.length > 0) &&
                <ComponentPaper elevation={2}>
                    <Box p={'16px'}>資料</Box>
                    <Divider/>
                    <Box p={'16px'}>
                        <AttachmentTable>
                            <TableHead>
                                <TableRow>
                                    <AttachmentNameCell>
                                        資料名
                                    </AttachmentNameCell>
                                    <AttachmentRegisteredUserCell>
                                        登録者
                                    </AttachmentRegisteredUserCell>
                                    <AttachmentRegisteredDatetimeCell>
                                        登録日時
                                    </AttachmentRegisteredDatetimeCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.renderMeetingAttachmentFilesTable(selectedMeeting.meetingAttachmentFileList)}
                                {this.renderMeetingAttachmentLinksTable(selectedMeeting.meetingAttachmentLinkList)}
                            </TableBody>
                        </AttachmentTable>
                    </Box>
                </ComponentPaper>
            }
            {
                selectedMeeting.meetingReportList.length > 0 &&
                <ComponentPaper elevation={2}>
                    <Box p={'16px'}>議事録</Box>
                    <Divider/>
                    <Box p={'16px'}>
                        <AttachmentTable>
                            <TableHead>
                                <TableRow>
                                    <AttachmentNameCell>
                                        資料名
                                    </AttachmentNameCell>
                                    <AttachmentRegisteredUserCell>
                                        登録者
                                    </AttachmentRegisteredUserCell>
                                    <AttachmentRegisteredDatetimeCell>
                                        登録日時
                                    </AttachmentRegisteredDatetimeCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.renderMeetingReportsTable(selectedMeeting.meetingReportList)}
                            </TableBody>
                        </AttachmentTable>
                    </Box>
                </ComponentPaper>
            }
            <ComponentPaper elevation={2}>
                <AdminMeetingCommentArea
                    {...this.props}
                    condominiumCd={this.props.condominiumCd}
                    meetingId={selectedMeeting.id}
                    meetingRepoForAdmin={this.props.meetingRepoForAdmin}
                    eventEmitter={this.props.eventEmitter}
                    havePostCommentAuthority={this.state.havePostCommentAuthority}
                    currentDatetime={this.state.currentDateTime.format('YYYY-MM-DDTHH:mm:ss')}
                />
            </ComponentPaper>
        </>)
    }

    renderMeetingArea(): ReactNode {
        const {
            meetings,
            selectedMeeting,
            meetingAnnounceNotifyDialogOpen,
            meetingAttendanceReplyRequestDialogOpen,
            notifyTitle,
            notifyBody,
            editAttendanceReplyDeadline,
            editProxyAttendanceAvailability,
            meetingAttendanceReplyRequestDialogFlowNumber,
            haveEditAuthority,
            currentDateTime,
        } = this.state

        const {eventEmitter} = this.props

        if (meetings.length === 0 || selectedMeeting === null) {
            return '会議が登録されていません。'
        }

        let names: OptionProps[]
        names = meetings.map((meeting) => {
            return ({
                label: `${meeting.name}`,
                value: `${meeting.id}`,
            })
        })

        const hasMeetingAssignableMember = selectedMeeting.participantAssocDirectorList.length > 0

        const isPastMeeting = MeetingHelper.checkPastMeeting(selectedMeeting, currentDateTime)

        return <>
            <Box mb={'16px'}>
                <MeetingListBox
                    data={names}
                    value={valueOrNoSelected(selectedMeeting.id)}
                    onChange={this.handleMeetingChange}
                    eventEmitter={eventEmitter}
                    fullWidth
                />
            </Box>
            {
                haveEditAuthority &&
                <ActionArea>
                    <EditLink onClick={this.handleClickEditButton}>
                        編集する
                    </EditLink>
                    <DeleteLink onClick={this.handleClickDeleteButton}>
                        削除する
                    </DeleteLink>
                </ActionArea>
            }
            <Box height={'8px'}/>
            <LeftTopRowFlexContainer>
                <Box flexBasis={'345px'} flexShrink={0}>
                    {
                        haveEditAuthority &&
                        this.renderMeetingAnnounceArea(selectedMeeting, hasMeetingAssignableMember, isPastMeeting)
                    }
                    {this.renderMeetingAttendanceArea(selectedMeeting, hasMeetingAssignableMember, isPastMeeting)}
                    {this.renderMemberArea(selectedMeeting, hasMeetingAssignableMember)}
                </Box>
                <Box ml={'16px'} flexGrow={1} overflow={'hidden'}>
                    {this.renderMeetingDetailArea(selectedMeeting)}
                </Box>
            </LeftTopRowFlexContainer>
            {
                meetingAnnounceNotifyDialogOpen &&
                <Dialog
                    id={'pp-dialog'}
                    open={meetingAnnounceNotifyDialogOpen}
                    transitionDuration={(process.env.NODE_ENV === 'test') ? 0 : undefined}
                    maxWidth={'md'}
                >
                    <AdminMeetingNotifyDialog
                        dialogTitle={'開催案内'}
                        dialogBody={'メンバーに向けて、開催案内メールを送信します。※メールは自分宛てにも同時に送信されます。\n素敵ネットアプリを所持しているメンバーは、アプリからの通知も受け取ることができます。'}
                        notifyTitle={notifyTitle}
                        notifyBody={notifyBody}
                        notifyButtonLabel={'開催案内を送信する'}
                        onNotify={this.handleNotifyForMeetingAnnounceDialog}
                        onClose={this.handleCloseForMeetingAnnounceDialog}
                    />
                </Dialog>
            }
            {
                meetingAttendanceReplyRequestDialogOpen &&
                <Dialog
                    id={'pp-dialog'}
                    open={meetingAttendanceReplyRequestDialogOpen}
                    transitionDuration={(process.env.NODE_ENV === 'test') ? 0 : undefined}
                    maxWidth={'md'}
                >
                    {
                        meetingAttendanceReplyRequestDialogFlowNumber === 1 && selectedMeeting.date !== null &&
                        <AdminMeetingAttendanceReplyRequestDialog
                            eventDate={new Date(selectedMeeting.date)}
                            attendanceReplyDeadline={editAttendanceReplyDeadline}
                            proxyAttendanceAvailability={editProxyAttendanceAvailability}
                            onNext={this.handleNextFlowForMeetingAttendanceReplyRequestDialog}
                            onClose={this.handleCloseForMeetingAttendanceReplyRequestDialog}
                            onChange={this.handleChangeForMeetingAttendanceReplyRequestDialogItem}
                        />
                    }
                    {
                        meetingAttendanceReplyRequestDialogFlowNumber === 2 &&
                        <AdminMeetingNotifyDialog
                            dialogTitle={'出欠回答依頼(2/2)'}
                            dialogBody={'メール内容を確認してください。※メールは自分宛てにも同時に送信されます。\n素敵ネットアプリを所持しているメンバーは、アプリからの通知も受け取ることができます。'}
                            notifyTitle={notifyTitle}
                            notifyBody={notifyBody}
                            notifyButtonLabel={'出欠回答を依頼する'}
                            onNotify={this.handleNotifyForMeetingAttendanceReplyRequestDialog}
                            onClose={this.handleCloseForMeetingAttendanceReplyRequestDialog}
                            onBack={this.handleBackFlowForMeetingAttendanceReplyRequestDialog}
                        />
                    }
                </Dialog>
            }
        </>
    }

    render(): ReactNode {
        if (!this.state.isLoadCompleted) {
            return null
        }

        return (<>
            <Box height={'8px'}/>
            {this.state.haveEditAuthority &&
                <>
                    <RowFlexContainer>
                        <StyledLink to={`/admin/condominiums/${this.props.condominiumCd}/meetings/register`}>
                            新しい会議を作成する
                        </StyledLink>
                    </RowFlexContainer>
                    <Box height={'16px'}/>
                </>
            }
            {this.renderMeetingArea()}
        </>)
    }
}

export default createAdminPage(AdminMeetingListPage)


const MeetingListBox = styled(PPSelect)`
  select {
    padding: 12px 8px 12px;
  }

  svg {
    margin-right: 8px;
  }

  &.MuiInputBase-root {
    padding: 5px;
  }
`

const ComponentPaper = styled(Paper)`
  width: 100%;
  margin-bottom: 16px;
`

const ActionArea = styled(RowFlexContainer)`
  width: 100%;
  justify-content: space-between;
`

const AttachmentTable = styled(Table)`
  &.MuiTable-root {
    border: 1px solid rgba(224, 224, 224, 1);
  }
`

const AttachmentHeaderCell = styled(TableCell)`
  &.MuiTableCell-root {
    padding-top: 4px;
    padding-bottom: 4px;
    font-size: 0.85em;
    color: ${Colors.AccentDark};
  }

  background-color: ${Colors.Background};
`

const AttachmentNameCell = styled(AttachmentHeaderCell)`
  width: 50%;
`

const AttachmentRegisteredUserCell = styled(AttachmentHeaderCell)`
  width: 35%;
`

const AttachmentRegisteredDatetimeCell = styled(AttachmentHeaderCell)`
  width: 15%;
`

const NowrapCell = styled(TableCell)`
  white-space: nowrap;
`

const DropShadowSvg = styled.svg`
  filter: drop-shadow(0 2px 2px rgba(217, 217, 217, 0.25));
`

const AttendanceArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const AttendanceIcon = styled.span<{ color: string }>`
  width: 20px;
  height: 20px;
  border-radius: 10px;
  display: inline-block;
  background: ${props => props.color};
`

const AttendanceRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 5px 0;
`

const RowCenteringContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`

const NotifyButton = styled(AdminPrimaryButton)`
  &.MuiButtonBase-root {
    width: 236px;
  }
`

const AttendanceResponseViewButton = styled(AdminPrimaryOutlinedButton)`
  &.MuiButtonBase-root {
    width: 236px;
  }
`


const MemberRoomNumberText = styled.span`
  padding-right: 16px;
  font-size: 12px;
  color: ${Colors.AccentDark};
  width: 100%;
  float: left;
  overflow: hidden;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
  white-space: nowrap;

  :hover {
    overflow: visible;
  }

  :hover span {
    position: relative;
    background-color: white;
    border: none;
  }
`

const MemberRoomNumberTextBody = styled.span`
  padding: 5px 5px 5px 0;
`

const MemberInfoBox = styled(LeftTopRowFlexContainer)`
  max-width: 313px;
  padding: 8px;
  align-items: center;
`

export const AttachmentFileStyle = styled.div`
  font-size: 21px;
  line-height: 1;
  min-width: 21px;
  text-align: center;
  margin-right: 8px;
  color: ${Colors.AccentDark};
`

const WarningMessageArea = styled.div`
  background: #F5A62333;
  font-weight: bold;
  margin: 0 -8px;
  padding: 8px;
  display: flex;
  align-items: flex-start;
`

const RoomNumberText = styled.span`
  white-space: normal;
  padding: 5px 16px 5px 0;
  width: 100%;
`
